module.exports = __webpack_public_path__ + "static/media/teacherImage.504e9bf3.png";